




























import { defineComponent, computed, watch } from '@vue/composition-api';
import { ChevronLeftIcon } from 'tdesign-icons-vue';

import useSSOLogin from '@/renderer/components/login/compositions/useSSOLogin';
import SelectInput from './SelectInput.vue';

export default defineComponent({
  components: { ChevronLeftIcon, SelectInput },
  props: { show: { type: Boolean } },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });

    const { corpId, corpIdList, loading, remoteCropList, methods: ssoMethods } = useSSOLogin();

    const methods = {
      cancel() {
        innerShow.value = false;
        context.emit('cancel');
      },
      submit() {
        ssoMethods.openSSOUrl();
      },
    };

    ssoMethods.initList();

    watch(remoteCropList, (val, old) => {
      if (val.length > 0 && old.length === 0) {
        ssoMethods.initList();
      }
    });

    return {
      innerShow,
      corpId,
      corpIdList,
      remoteCropList,
      loading,
      ...methods,
    };
  },
});
